import React from 'react';
import { Trophy, Award, Sparkles } from 'lucide-react';
interface StatsHeaderProps {
  totalRewards: number;
  badgesOwned: number;
  skinsOwned: number;
}
export const StatsHeader: React.FC<StatsHeaderProps> = ({
  totalRewards,
  badgesOwned,
  skinsOwned
}) => {
  return <div className="relative mb-8 overflow-hidden" data-id="element-21080">
      {/* Main header content */}
      <div className="relative bg-gradient-to-r from-pink-100 via-purple-100 to-indigo-100 dark:from-[#0f0c29] dark:via-[#302b63] dark:to-[#24243e] rounded-lg p-6 text-gray-800 dark:text-white shadow-sm dark:shadow-[0_0_15px_rgba(138,43,226,0.3)] backdrop-blur-sm border border-purple-200/30 dark:border-indigo-500/20" data-id="element-21081">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4" data-id="element-21082">
          <div data-id="element-21083">
            <h2 className="text-2xl font-bold mb-1 text-gray-800 dark:text-transparent dark:bg-clip-text dark:bg-gradient-to-r dark:from-purple-300 dark:to-indigo-200" data-id="element-21084">
              Your Stats
            </h2>
            <p className="text-gray-600 dark:text-indigo-200/80 text-sm" data-id="element-21085">
              Track your progress, relationships, lootboxes, and rewards across
              SinShift.
            </p>
          </div>
          <div className="flex items-center gap-3" data-id="element-21086">
            <div className="bg-white/80 dark:bg-indigo-900/50 backdrop-blur-sm rounded-lg px-3 py-2 border border-purple-200/30 dark:border-indigo-500/30 shadow-sm dark:shadow-[0_0_10px_rgba(79,70,229,0.2)] flex items-center gap-1.5 arcane-stat" data-id="element-21087">
              <Trophy size={16} className="text-amber-500 dark:text-amber-300" data-id="element-21088" />
              <span className="text-sm font-medium text-gray-700 dark:text-amber-100" data-id="element-21089">
                {totalRewards} Rewards
              </span>
            </div>
            <div className="bg-white/80 dark:bg-purple-900/50 backdrop-blur-sm rounded-lg px-3 py-2 border border-purple-200/30 dark:border-purple-500/30 shadow-sm dark:shadow-[0_0_10px_rgba(168,85,247,0.2)] flex items-center gap-1.5 arcane-stat" data-id="element-21090">
              <Award size={16} className="text-purple-500 dark:text-purple-300" data-id="element-21091" />
              <span className="text-sm font-medium text-gray-700 dark:text-purple-100" data-id="element-21092">
                {badgesOwned} Badges
              </span>
            </div>
            <div className="bg-white/80 dark:bg-blue-900/50 backdrop-blur-sm rounded-lg px-3 py-2 border border-purple-200/30 dark:border-blue-500/30 shadow-sm dark:shadow-[0_0_10px_rgba(59,130,246,0.2)] flex items-center gap-1.5 arcane-stat" data-id="element-21093">
              <Sparkles size={16} className="text-blue-500 dark:text-blue-300" data-id="element-21094" />
              <span className="text-sm font-medium text-gray-700 dark:text-blue-100" data-id="element-21095">
                {skinsOwned} Skins
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>;
};